<template>
    <div class="card-sticky">
        <prismic-image
            :img="document.data.image"
            w="242"
            h="153"
            :lazy="false"
            class="card-img"
        />

        <card-rating 
            :rating="document.data.core_api.ratings.average_score" 
            :card="document"
        />

        <data-boxes :model="model" />

        <button-target
            background="orange"
            size="md"
            :link="document"
        />
    </div>
</template>

<script>
import CardRating from '@/components/features/CardRating.vue';
import DataBoxes from '@/components/slices/list/list-item/list-item-components/DataBoxes.vue';
export default {
    components: { CardRating, DataBoxes },
    props: {
        document: {
            type: Object,
            required: true,
            default: () => {}
        },
        model: {
            type: Object,
            required: true,
            default: () => {}
        }
    }
};
</script>

<style lang="scss" scoped>
.card-sticky::v-deep {
    @include border-radius(10px);
    @include grid(1,20px);
    background: $white;
    box-shadow: $bxs;
    @include border;
    width: 100%;
    margin-bottom: 8px;

    @media screen and (max-width: 1000px) {
        @include spacing(padding,8);
    }

    @media screen and (min-width: 1000px) {
        @include spacing(padding,6);

    }

    ul {
        li {
            padding: 10px 0;
            @include flex;
            font-size: 14px;
            @include border(bottom);
            &:last-child { border: 0; }

            span {
                &:first-child {
                    font-weight: bold;
                    flex: 1;
                }
            }
        }
    }

    .data-boxes {
        @include border(0);
        @include device(pad) {
            @include border((top,bottom));
        }
        @media screen and (min-width: 1000px) {
            @include border(0);
        }

        &__box {
            border: 0;
        }
        &__box.mid {
            @include border((top,bottom));
            @include device(pad) {
                @include border(0);
            }
            @media screen and (min-width: 1000px) {
                @include border((top,bottom));
            }

        }

        @media screen and (min-width: 1000px) {
            @include grid(1,0px);

            &__box {
                @include flex;

                span {
                    flex: 1;
                    &:last-child { text-align: right; }
                }
                .foot {
                    justify-content: flex-end;
                }
            }
        }
    }

    .btn {
        width: 100%;
        margin: auto;

        @include device(pad) {
            max-width: 300px;
        }
    }

    .card-img {
        margin: auto;
        width: 100%;
        height: auto;
        max-width: 260px;
    }
}
</style>
